import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class AmmoniaAmmoniumSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.AmmoniaAmmoniumSensor,
    });
  }
}
